import React from "react";
import { NavBarThree } from "../components/Header";
import { FootBar } from "../components/Footer";
import { useQuery } from "@tanstack/react-query";
import { ImageProfil } from "../components/Form";
import { RepositoriesContainer, UserContainer } from "../components/Container";
import { UserApi } from "../app/api/user.api";


export function Panel()
{
    const user = UserApi();
        
    const findUser = async () => {
        const {data} = await user.findCurUser();
        return data.data;
    };
             
    const { data, isLoading, error } = useQuery({
        queryKey: ["user"],
        queryFn: findUser,
    });


    return(

        <div className="container-fluid">
            <div className="row"> 
                {/* *************************************************************** */}
                <div className="col-lg-12 sticky-top bg-light border-bottom">  <NavBarThree target={'panel'} />  </div>
                {/* ************************************************* */}
                <div className="col-md-12">  
                    <div className="row min-vh-100">  
                        {/* ---------------------------------------------------------- */}
                        <div className="col-lg-3 py-5 border-bottom bg-light">
                            <ImageProfil data={data} isLoading={isLoading} />
                            <UserContainer isLoading={isLoading} error={error} data={data} />
                        </div>
                        {/* ---------------------------------------------------------- */}
                        <div className="col-lg-6 border-start border-bottom bg-light">  
                            <RepositoriesContainer />  
                        </div>
                        {/* ---------------------------------------------------------- */}
                        <div className="col-lg-3 border-start p-3 bg-light">
                            <div className="d-flex flex-column white border rounded-3">
                                <div className="lead text-dark px-4 border-bottom py-3 bg-green rounded-top-3 text-white"> Guide d'information </div>
                                <div className="text-secondary p-4 border-bottom bg-white"> 
                                    Les documents sont organises dans des dossiers prédéfinis par le système.
                                </div>
                                <div className="text-muted px-4 py-3 bg-light border-bottom"> Les documents sont organises </div>
                                <div className="text-secondary p-4 border-bottom bg-white"> 
                                    Les documents sont organises dans des dossiers prédéfinis par le système. Ces dossiers sont contenus dans un répertoire que l'utilisateur doit créer en cliquant sur
                                </div>
                                <div className="text-muted px-4 py-3 bg-light border-bottom"> Les documents sont organises </div>
                                <div className="text-secondary p-4 border-bottom bg-white rounded-bottom-3">  
                                    Les documents sont organises dans des dossiers prédéfinis par le système. Ces dossiers sont contenus dans un répertoire que l'utilisateur doit créer en cliquant sur
                                </div>
                            </div>
                        </div>
                        {/* ---------------------------------------------------------- */} 
                    </div>     
                </div> 
                {/* *************************************************************** */}
                <div className="col-lg-12 bg-dark">  <FootBar />  </div>
            </div>
        </div>     
    )
}


